import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import * as d3 from 'd3';
import css_248z from './scatterPlotChart.styles.css.js';

let HTScatterPlotChart = class HTScatterPlotChart extends LitElement {
    constructor() {
        super(...arguments);
        this.data = [];
        this.highlightCompany = '';
        this.labels = [];
    }
    firstUpdated() {
        this.renderChart();
    }
    updated(changedProperties) {
        if (changedProperties.has('data') ||
            changedProperties.has('highlightCompany')) {
            this.renderChart();
        }
    }
    renderChart() {
        var _a, _b;
        if (!this.data.length)
            return;
        const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('ht-scatter-plot-chart');
        if (!container)
            return;
        const width = container.clientWidth;
        const height = Math.round(width * 0.65);
        const margin = { top: 20, right: 30, bottom: 30, left: 40 };
        const xMax = d3.max(this.data, (d) => Math.abs(d['axis_x'])) || 1;
        const yMax = d3.max(this.data, (d) => Math.abs(d['axis_y'])) || 1;
        const x = d3
            .scaleLinear()
            .domain([-xMax, xMax])
            .nice()
            .range([margin.left, width - margin.right]);
        const y = d3
            .scaleLinear()
            .domain([-yMax, yMax])
            .nice()
            .range([height - margin.bottom, margin.top]);
        const svg = d3.select((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('svg'));
        svg.selectAll('*').remove();
        svg.attr('viewBox', [0, 0, width, height]);
        svg
            .append('g')
            .attr('transform', `translate(0,${y(0)})`)
            .call(d3.axisBottom(x).tickSize(0))
            .call((g) => g.selectAll('.tick text').remove())
            .call((g) => g.select('.domain').attr('stroke', 'var(--scatter-axis-color)'));
        svg
            .append('g')
            .attr('transform', `translate(${x(0)},0)`)
            .call(d3.axisLeft(y).tickSize(0))
            .call((g) => g.selectAll('.tick text').remove())
            .call((g) => g.select('.domain').attr('stroke', 'var(--scatter-axis-color)'));
        const tooltipBg = getComputedStyle(this)
            .getPropertyValue('--scatter-tooltip-bg')
            .trim();
        const tooltipTextColor = getComputedStyle(this)
            .getPropertyValue('--scatter-tooltip-text')
            .trim();
        const tooltipFontSize = getComputedStyle(this)
            .getPropertyValue('--scatter-tooltip-font-size')
            .trim();
        let tooltip = d3
            .select(document.body)
            .select('.tooltip')
            .style('position', 'absolute')
            .style('pointer-events', 'none')
            .style('background', tooltipBg)
            .style('color', tooltipTextColor)
            .style('padding', '5px')
            .style('border-radius', '4px')
            .style('font-size', tooltipFontSize);
        if (tooltip.empty()) {
            tooltip = d3.select(document.body).append('div').attr('class', 'tooltip');
        }
        svg
            .append('text')
            .attr('x', margin.left)
            .attr('y', margin.top)
            .attr('text-anchor', 'start')
            .attr('fill', 'var(--scatter-axis-color)')
            .style('font-size', '18px')
            .text(this.labels[0]);
        svg
            .append('text')
            .attr('x', width - margin.right)
            .attr('y', margin.top)
            .attr('text-anchor', 'end')
            .attr('fill', 'var(--scatter-axis-color)')
            .style('font-size', '18px')
            .text(this.labels[1]);
        svg
            .append('text')
            .attr('x', margin.left)
            .attr('y', height - margin.bottom)
            .attr('text-anchor', 'start')
            .attr('fill', 'var(--scatter-axis-color)')
            .style('font-size', '18px')
            .text(this.labels[2]);
        svg
            .append('text')
            .attr('x', width - margin.right)
            .attr('y', height - margin.bottom)
            .attr('text-anchor', 'end')
            .attr('fill', 'var(--scatter-axis-color)')
            .style('font-size', '18px')
            .text(this.labels[3]);
        svg
            .append('g')
            .selectAll('circle')
            .data(this.data)
            .join('circle')
            .attr('cx', (d) => x(d['axis_x']))
            .attr('cy', (d) => y(d['axis_y']))
            .attr('r', 4)
            .attr('fill', (d) => d['ticker'] === this.highlightCompany
            ? 'var(--scatter-highlight-color)'
            : 'var(--scatter-point-color)')
            .on('mouseenter', (evt, d) => {
            tooltip
                .style('top', `${evt.pageY + 10}px`)
                .style('left', `${evt.pageX - 20}px`)
                .style('opacity', 1)
                .style('visibility', 'visible')
                .html(`<strong>${d.company}</strong>`);
            console.log('tooltip', tooltip);
        })
            .on('mouseleave', () => {
            tooltip.style('opacity', 0).style('visibility', 'hidden');
        });
    }
    render() {
        return html `<div id="ht-scatter-plot-chart">
      <svg></svg>
    </div>`;
    }
};
HTScatterPlotChart.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: Array })
], HTScatterPlotChart.prototype, "data", void 0);
__decorate([
    property({ type: String })
], HTScatterPlotChart.prototype, "highlightCompany", void 0);
__decorate([
    property({ type: Array })
], HTScatterPlotChart.prototype, "labels", void 0);
HTScatterPlotChart = __decorate([
    customElement('ht-scatter-plot-chart')
], HTScatterPlotChart);
var HTScatterPlotChart$1 = HTScatterPlotChart;

export { HTScatterPlotChart$1 as default };
//# sourceMappingURL=scatterPlotChart.js.map
